
  import { removeEmpty } from '~/utils/tools.js'
  import { getHomePageConfig } from '~/api/home/index.js'

  export default {
    name: 'StretchBanner',

    props: {
      title: {
        type: String,
        default: '',
      },
      sub: {
        type: String,
        default: '',
      },
      introduce: {
        type: String,
        default: '',
      },
      mobileSub: {
        type: String,
        default: '',
      },
      mainIcon: {
        type: String,
        default: '',
      },
      desc: {
        type: String,
        default: '',
      },
      pageType: {
        type: String,
        default: 'satisfaction',
      },
      // 每个页面自己独立的 配置跳转页面
      href: {
        type: String,
        default: '',
      },
      //  最小宽度, 在不同的落地页 需要配置自己相应的宽度设计
      minWidth: {
        type: String,
        default: '',
      },
      width: {
        type: String,
        default: '',
      },
      pcLoginText: {
        type: String,
        default: '免费使用',
      },
    },
    data() {
      return {
        defData: Object.freeze({
          satisfaction: {
            title: '专业易用的<span class="color-primary">满意度调查</span>',
            mobileTitle: '<span>专业易用的<span class="color-primary">满意度调查</span>',
            sub: '员工满意度 ·服务满意度 ·客户满意度',
            mainIcon: require('~/assets/image/stretch-banner/satisfaction-main.png'),
            mobileSub: '员工满意度 ·服务满意度 ·客户满意度',
            mobileClass: 'column-reverse',
            desc: '已帮助<span class="color-primary">2,263万</span>用户收集了<span class="color-primary">20.0亿</span>份答卷',
            logoIcon: require('~/assets/image/stretch-banner/logos.png'),
            mobileLogoIcon: require('~/assets/image/stretch-banner/logos-mobile.png'),
            hasOperator: true,
            href: '/create/scene/create-template/?scene=satisfaction',
            maxWidth: '1250px',
          },
          survey: {
            title: '<span class="color-primary">问卷调查</span>就用问卷网',
            mobileTitle: '<span class="color-primary">问卷调查</span>就用问卷网',
            mainIcon: require('~/assets/image/stretch-banner/survey-main.png'),
            sub: '市场调查·用户调查·员工调查·<a href="/edu/" class="mouse-pointer" target="_blank">学术调查</a>',
            mobileSub: '市场调查·用户调查·员工调查·学术调查',
            mobileClass: 'column-reverse',
            desc: '已帮助<span class="color-primary">2,263万</span>用户收集了<span class="color-primary">20.0亿</span>份答卷',
            logoIcon: require('~/assets/image/stretch-banner/logos.png'),
            mobileLogoIcon: require('~/assets/image/stretch-banner/logos-mobile.png'),
            hasOperator: true,
            href: '/create/scene/create-template/?scene=survey',
          },
          assess: {
            title: '问卷网<br/>让考试测评简单高效',
            mobileTitle: '问卷网让考试测评简单高效',
            mainIcon: require('~/assets/image/stretch-banner/assess-main.png'),
            mobileSub: '高效 · 便捷 · 易用',
            mobileClass: 'column-reverse',
            logoIcon: require('~/assets/image/stretch-banner/assess-logos.png'),
            mobileLogoIcon: require('~/assets/image/stretch-banner/mobile-assess-logos.png'),
            hasOperator: true,
            href: '/create/scene/create-template/?scene=assess',
          },
          app: {
            title: '问卷网APP<br/>你的随身问卷助手',
            mobileTitle: '问卷网APP你的随身问卷助手',
            mainIcon: require('~/assets/image/stretch-banner/app-main.png'),
            sub: '高效·便捷·易用',
            mobileSub: '高效·便捷·易用',
            mobileClass: 'column',
            desc: '',
            hasOperator: false,
            hasQrcode: true,
          },
          knowledge: {
            title: '<span class="knowledge-title">大型知识竞赛活动轻松支持</span>',
            mobileTitle: '<span class="knowledge-mobile">大型知识竞赛活动轻松支持</span>',
            href: '/create/scene/create-template/?scene=scholarism&sceneName=知识竞赛',
            mainIcon: 'https://s1.wenjuan.com/assets/images/homesite/scence-page/knowledge/nav-bar/pc-818.png',
            sub: '<span class="sub-knowledge">趣味科普 | 安全宣传 | 技能培训 | 弘扬传统<span>',
            mobileSub: '<span class="mobileSub-knowledge">趣味科普 | 安全宣传 | 技能培训 | 弘扬传统<span>',
            mobileClass: 'column-reverse',
            hasOperator: true,
            maxWidth: '1024px',
          },
          appraise: {
            title: '<span class="color-primary">问卷网</span>360评估',
            mobileTitle: '<span class="color-primary">问卷网</span>360评估',
            sub: '<span class="sub-knowledge">更全面的人才测评解决方案<span>',
            mobileSub: '<span class="mobileSub-knowledge">更全面的人才测评解决方案<span>',
            href: '/create/scene/create-template/?scene=appraise&sceneName=360评估',
            mainIcon: 'https://s1.wenjuan.com/assets/images/homesite/scence-page/appraise/nav-bar/pc-509.png',
            mobileClass: 'column-reverse',
            logoIcon: require('~/assets/image/stretch-banner/logos.png'),
            mobileLogoIcon: require('~/assets/image/stretch-banner/logos-mobile.png'),
            desc: '<span></span>',
            introduce:
              '多角色多维度的评估系统、简单易用的操作方式、内容丰富的评估报告，让您更轻松、更全面地了解员工发展情况',
            mobileIntroduce:
              '多角色多维度的评估系统、简单易用的操作方式、内容丰富的评估报告，让您更轻松、更全面地了解员工发展情况',
            hasOperator: true,
          },
          collect: {
            title: '<span class="color-primary">问卷网样本服务</span><br/>助力学术研究与市场洞察',
            mobileTitle: '<span class="color-primary">问卷网样本服务</span><br/>助力学术研究与市场洞察',
            sub: '<span>已为超过 <span class="error-color">5,087</span> 家调研小组/企业收集了 <span class="error-color">15,044,841</span> 份具有多样性和代表性的样本<span>',
            mobileSub:
              '<span>已为超过 <span class="error-color">5,087</span> 家调研小组/企业收集了 <span class="error-color">15,044,841</span> 份具有多样性和代表性的样本<span>',
            href: '/create/scene/create-template/?scene=appraise&sceneName=360评估',
            mainIcon: 'https://s1.wenjuan.com/assets/images/homesite/scence-page/collect/collect.png',
            mobileClass: 'column-reverse',
            hasOperator: true,
            noNeedLogin: true,
            btnText: '开启调研',
          },
          ai: {
            title: '<span class="ai-title">做问卷，不妨<div class="ai-text"></div></span>',
            mobileTitle: '<span class="ai-title">做问卷，不妨<div class="ai-text"></div></span>',
            sub: '<span>一句话就能轻松创建问卷，还能自动生成分析报告<span>',
            mobileSub: '<span>一句话就能轻松创建问卷，还能自动生成分析报告<span>',
            href: '/create/scene/create-template/?scene=appraise&sceneName=360评估',
            mainIcon: 'https://s1.wenjuan.com/assets/images/homesite/scence-page/ai/wen-pc.png',
            mobileClass: 'column-reverse',
            hasOperator: true,
            noNeedLogin: true,
            btnText: '体验AI调研',
            introduce:
              '<span>问问AI已创建<span class="blob">26万</span>份问卷，回收<span class="blob">5256万</span>份数据<span>',
            mobileBottomIntroduce:
              '<span>问问AI已创建<span class="blob">26万</span>份问卷，回收<span class="blob">5256万</span>份数据<span>',
          },
          cra: {
            title: '<span class="color-gradient">市调大赛</span>就用问卷网',
            mobileTitle: '<span class="color-gradient">市调大赛</span>就用问卷网',
            sub: '<span>问卷调查·样本收集·数据分析·学习资源<span>',
            mobileSub: '<span>问卷调查·样本收集·数据分析·学习资源<span>',
            href: '/create/scene/create-template/?scene=appraise&sceneName=360评估',
            mainIcon: 'https://s1.wenjuan.com/assets/images/homesite/cra/wenwen-image-.png',
            mobileClass: 'column-reverse',
            hasOperator: true,
            noNeedLogin: true,
            btnText: '领取专属福利',
            introduce:
              '十年护航，已帮助<span class="blob">115万</span>参赛学生收集了<span class="blob">2660万</span>份答卷',
            mobileBottomIntroduce:
              '十年护航，已帮助<span class="blob">115万</span>参赛学生收集了<span class="blob">2660万</span>份答卷',
          },
        }),
        fullTop: '-88px',
        WeiXinUrl: '',
      }
    },
    async fetch() {
      await getHomePageConfig().then((res) => {
        this.WeiXinUrl = res.data.wechat_login_url
      })
    },
    computed: {
      isMobile() {
        return this.$store.state.isMobile && this.innerWidth < 1024
      },
      innerWidth() {
        return this.$store.state.innerWidth
      },
      bannerData() {
        const { title, sub, introduce, mainIcon, pageType } = this
        const obj = removeEmpty({
          title,
          sub,
          introduce,
          mainIcon,
        })
        return { ...this.defData[pageType], ...obj }
      },
      loggedIn() {
        return this.$store.state.loginStatus.loggedIn == 1
      },
      uaObj() {
        return { ...this.$store.state.mediaType }
      },
      isHandset() {
        return this.$store.state.isMobile
      },
    },
    fetchOnServer: false,
    methods: {
      mobileclick() {
        if (!this.loggedIn) {
          this.$store.commit('setLoginStatus', {
            mobileVisible: true,
          })
        }
      },
    },
  }
